import { format } from "date-fns";

// option.sb.dayが有効の場合、当日以外はサービス開始ボタンを非活性化
const isDisabledButtonAlways = (options, selectedDate) => {
  if (
    options &&
    options.sb &&
    options.sb.day === 1 &&
    format(new Date(), "yyMMdd") !== format(new Date(selectedDate), "yyMMdd")
  ) {
    return true;
  } else {
    return false;
  }
};

const isDisabledButtonByPosition = (options) => {
  if (options && options.sb && options.sb.position === 1) {
    return true;
  } else {
    return false;
  }
};

export const isDisabledButtonDefault = (options, selectedDate) => {
  return (
    isDisabledButtonByPosition(options) ||
    isDisabledButtonAlways(options, selectedDate)
  );
};

export const shouldWatchPosition = (position, options, selectedDate) => {
  return (
    position &&
    isDisabledButtonByPosition(options) &&
    !isDisabledButtonAlways(options, selectedDate)
  );
};

/**
 * 緯度経度情報が未登録かどうかを判定する
 * @param {*} options 設定
 * @param {String} position 緯度,経度の文字列
 * @returns {Boolean} 利用者宅付近のみかつ、緯度経度が未登録ならtrue
 */
export const isGeoUnregistered = (options, position) =>
  options && options.sb && options.sb.position === 1 && !position;

export const isAnywhare = (options) =>
  options && options.sb && options.sb.position === 0;
